import { useEffect, useState } from 'react';
import { Dialog, Button, Heading, Avatar, IconButton, Empty, Link, Badge, ButtonArea } from '../../components/base';
import { IPluginPromptData } from '../../libs/models/studio/PluginPromptList';
import { Aionu } from '../../libs/models/app/AIONU';
import { usePlugin } from '../../libs/hooks/usePlugin';

const AIONU_IMAGE = `${process.env.REACT_APP_STORAGE_IMAGE_URL}/image/icon_aionu.png`;
const AIONU_URL = 'https://studio.abclab.ktds.com';

interface AionuCreateDialogprops {
  email?: string;
  isOpen: boolean;
  onSave: () => void;
  onClose: () => void;
  setFormData: React.Dispatch<React.SetStateAction<IPluginPromptData>>;
}

const AionuCreateDialog: React.FC<AionuCreateDialogprops> = ({ isOpen, onSave, onClose, setFormData }) => {
  const plugin = usePlugin();
  const [aionuData, setAionuData] = useState<Aionu[]>([
    {
      id: 'f22c0809-d121-4f4a-8ff9-d36a34dcc8bb',
      name: 'ddd',
      description: 'ddd',
      mode: 'chat',
      api_key: 'app-jGQbtXfLZFIo3NzQMkjpIUdp',
      vision: true,
      user_input_form: null,
    },

    {
      id: 'b7d66344-0ca0-454e-9535-01a18691b7d9',
      name: 'Antbot AI 매뉴얼',
      description: '',
      mode: 'chat',
      api_key: 'app-LL0WsvRsIlnni3WnDqnMssHU',
      vision: false,
      user_input_form: [],
    },
    {
      id: '06c49612-ac93-4777-82a5-ced4849e4bf3',
      name: '검색 에이전트',
      description: '사용자가 질문하는 내용에 대해 bing  search를 이용해서 검색해 주는 에이전트 입니다.',
      mode: 'agent-chat',
      api_key: 'app-g914q4FwEz1GhfwlBgkKzV8r',
      vision: true,
      user_input_form: [
        {
          text_input: {
            label: '이름',
            variable: 'name',
            required: true,
            max_length: 48,
            default_var: '홍길동',
          },
        },
        {
          select: {
            label: '나이',
            variable: 'age',
            required: true,
            options: ['10대', '20대', '30대'],
            default_var: '10대',
          },
        },
      ],
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);

  // const [aionuData, setAionuData] = useState<Aionu[]>([
  //   {
  //     id: 'f22c0809-d121-4f4a-8ff9-d36a34dcc8bb',
  //     name: 'ddd',
  //     description: 'ddd',
  //     mode: 'chat',
  //     api_key: 'app-jGQbtXfLZFIo3NzQMkjpIUdp',
  //     vision: true,
  //     user_input_form: null,
  //   },

  //   {
  //     id: 'b7d66344-0ca0-454e-9535-01a18691b7d9',
  //     name: 'Antbot AI 매뉴얼',
  //     description: '',
  //     mode: 'chat',
  //     api_key: 'app-LL0WsvRsIlnni3WnDqnMssHU',
  //     vision: false,
  //     user_input_form: [],
  //   },
  //   {
  //     id: '06c49612-ac93-4777-82a5-ced4849e4bf3',
  //     name: '검색 에이전트',
  //     description: '사용자가 질문하는 내용에 대해 bing  search를 이용해서 검색해 주는 에이전트 입니다.',
  //     mode: 'agent-chat',
  //     api_key: 'app-g914q4FwEz1GhfwlBgkKzV8r',
  //     vision: true,
  //     user_input_form: [
  //       {
  //         text_input: {
  //           label: '이름',
  //           variable: 'name',
  //           required: true,
  //           max_length: 48,
  //           default_var: '홍길동',
  //         },
  //       },
  //       {
  //         select: {
  //           label: '나이',
  //           variable: 'age',
  //           required: true,
  //           options: ['10대', '20대', '30대'],
  //           default_var: '10대',
  //         },
  //       },
  //     ],
  //   },
  // ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const data = await plugin.getAionu();
        // const data = await plugin.getAionu('aionu@kt.com');
        setAionuData(data);
      } catch (error) {
        console.error('Failed to fetch Aionu data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchData();
  }, []);

  // // aionu agent 호출 로직
  // fetch('https://api.aionu.edu-tech.io/console/api/Link_AppList?email=solar.py@kt.com', {
  //   method: 'GET',
  //   headers: {
  //     Authorization:
  //       // 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiN2QyYjQwOWUtNmRiMS00YzQ4LWFkNWEtNmI1ZDQxOWQxYjI1IiwiZXhwIjo0ODkyMjQ1NjUxLCJpc3MiOiJTRUxGX0hPU1RFRCIsInN1YiI6IkNvbnNvbGUgQVBJIFBhc3Nwb3J0In0.iaKbmNIMJdAmQtDAhac5g_aB7RNcNpQIGcJBLCvsNr8',
  //       'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiN2QyYjQwOWUtNmRiMS00YzQ4LWFkNWEtNmI1ZDQxOWQxYjI1Iiwicm9sZXMiOltdLCJleHAiOjQ4ODQzOTcyOTksImlzcyI6IlNFTEZfSE9TVEVEIiwic3ViIjoiQ29uc29sZSBBUEkgUGFzc3BvcnQifQ.TqS8tRhZZkXCmOhcZY6EueOy7o-MzfccbwIxrGD_eeE',
  //   },
  // })
  //   .then((response) => response.json())
  //   .then((data) => console.log(data))
  //   .catch((error) => console.error('Error:', error));

  // // aionu agent param 호출 로직
  // fetch('https://api-dev.aionu.edu-tech.io/v1/parameters', {
  //   method: 'GET',
  //   headers: {
  //     Authorization: 'Bearer app-AzbgHM7tgIBKSjY3QX3GxTdF',
  //   },
  // })
  //   .then((response) => response.json())
  //   .then((data) => console.log(data))
  //   .catch((error) => console.error('Error:', error));

  const handleRegister = () => {
    onSave();
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} className="studio-read">
      <div className="read-detail aionu-detail">
        <div className="det-head center">
          <Avatar size="2" src={AIONU_IMAGE} label="프로필 이미지" />
          <Heading as="h2" size="title3" weight="semibold">
            {/* ABC Lab agent 목록 */}
            ABC Lab 목록
          </Heading>

          <div className="d-utils">
            <IconButton name="closeLarge" className="dsx-Dialog-close" onClick={onClose}>
              닫기
            </IconButton>
          </div>
        </div>

        {isLoading ? (
          <div className="det-body aionu-card">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="aionu-card-item is-skeleton"></div>
            ))}
          </div>
        ) : aionuData.length === 0 ? (
          <Empty icon="nodata" title="생성된 ABC Lab 에이전트가 없습니다.">
            <Button size="default" variant="secondary" onClick={() => window.open(AIONU_URL, '_blank')}>
              ABC Lab 이동하기
            </Button>
          </Empty>
        ) : (
          <div className="det-body aionu-card">
            {aionuData.map((item) => (
              <Link
                className="aionu-card-item"
                key={item.id}
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    name: item.name,
                    description: item.description ?? '설명 없음',
                    tags: [item.mode, ...(item.vision ? ['Vision'] : [])],
                    aiOnUIConnectData: {
                      apiKey: item.api_key,
                      openingStatement: item.openingStatement,
                      conversationStarters: item.suggestedQuestions,
                      useWorksAIConversationStarters: true,
                    },
                  }));
                  handleRegister();
                }}
              >
                <div className="card-body">
                  <div className="b-tag">
                    <Badge variant="tint" size="large" accent="primary">
                      {item.mode}
                    </Badge>{' '}
                    {item.vision && (
                      <Badge variant="tint" size="large" accent="primary">
                        Vision
                      </Badge>
                    )}
                  </div>
                  <strong className="b-tit">{item.name}</strong>
                  <p className="b-txt">{item.description ?? '설명 없음'}</p>{' '}
                </div>
              </Link>
            ))}
          </div>
        )}
        <div className="det-foot"></div>
        <ButtonArea align="full">
          <Button size="large" variant="outline" onClick={onClose}>
            취소
          </Button>
          <Button
            size="large"
            variant="primary"
            onClick={() => {
              handleRegister();
            }}
          >
            적용하기
          </Button>
        </ButtonArea>
      </div>
    </Dialog>
  );
};

export default AionuCreateDialog;
